// extracted by mini-css-extract-plugin
module.exports = {"root":"OutletManger_root__3f1Y0","warningValue":"OutletManger_warningValue__3iWGB","specPriceValue":"OutletManger_specPriceValue__17f5m"};